<template>
  <div class="glide_item">
    <div class="item">
      <img class="img_style" :src="imgUrl" loading="lazy" alt>
      <div class="space_1"/>
      <div class="text-center px-md-5 px-sm-3 px-3">
        <img class="icon_style" :src="iconUrl" loading="lazy" alt>
        <div class="space_2"/>
        <hr class="m-0 border-white"/>
        <div class="space_1"/>
        <div class="info" v-html="info"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlideItem",
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
    iconUrl: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: true,
    }
  },
}
</script>

<style lang="scss">
.glide_item .item {
  width: 300px;
  height: 470px;
  border-radius: 0px 40px 0px 40px;
  background: #D56835;
}

@media (max-width: 992px) {
  .glide_item .item {
    width: 30vw;
    height: 47vw;
  }
}

@media (max-width: 576px) {
  .glide_item .item {
    width: 160px;
    height: 250px;
  }
}

.glide_item .img_style {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 0px 40px 0px 0px;
}

@media (max-width: 992px) {
  .glide_item .img_style {
    height: 22vw;
  }
}

@media (max-width: 576px) {
  .glide_item .img_style {
    height: 115px;
  }
}


.glide_item .space_1 {
  height: 16px
}

@media (max-width: 576px) {
  .glide_item .space_1 {
    height: 8px;
  }
}

.glide_item .icon_style {
  width: 72px;
  height: 72px;
  object-fit: cover;
}

@media (max-width: 992px) {
  .glide_item .icon_style {
    width: 7vw;
    height: 7vw;
  }
}

@media (max-width: 576px) {
  .glide_item .icon_style {
    width: 36px;
    height: 36px;
  }
}

.glide_item .space_2 {
  height: 8px;
}

@media (max-width: 576px) {
  .glide_item .space_2 {
    height: 4px;
  }
}

.glide_item .info {
  font-family: Noto Sans TC;
  font-size: 24px;
  font-weight: 400;
  text-align: left;
  color: white;
  line-height: 30px;
}

@media (max-width: 992px) {
  .glide_item .info {
    font-size: 2vw;
    line-height: 2.5vw;
  }
}

@media (max-width: 576px) {
  .glide_item .info {
    font-size: 14px;
    line-height: 16px;
  }
}

.glide_item .point {
  font-family: Noto Sans TC;
  font-weight: 900;
  text-align: left;
  color: #88FFD4;
  text-decoration: underline;
}
</style>
